<template>
  <div class="column">
    <!-- 発売日 -->
    <label class="name">発売日</label>

    <div v-if="isVisibleReleaseDate" class="value">
      {{ displayDate(date) }}
    </div>
    <div v-else class="value">
      ****.**.**
    </div>
  </div>
</template>

<script>
export default {
  name: "BMyTicketReleaseDateDisp",
  props: {
    date: {
      type: String,
      required: true,
    },
    isVisibleReleaseDate: {
      type: Boolean,
      required: true,
    }
  },
};
</script>

<style lang="scss" scoped>
.column {
  display: flex;
  margin-bottom: 20px;
  font-size: 14px;
}

.column label {
  width: 110px;
  color: #888888;
}

.column .value {
  width: calc(100% - 110px);
  font-weight: bold;
  color: black;
}
</style>
